module.exports = __webpack_public_path__ + "static/media/aw.a19d9d18.svg";